import React from 'react';
import { connect } from 'react-redux';
import ReactEcharts from '../lazy/Echarts';
import { dateTime, parseStringToFloat } from '../../utils/parsing';
import { ECHARTS_COLORS } from '../../redux/constants/colors';

class TrendGraph extends React.PureComponent {
  getOption() {
    const {
      title = '',
      yAxis = [{ type: 'value' }],
      labels,
      xAxisData,
      series,
      timezone,
      units,
    } = this.props;
    const option = {
      title: {
        text: title,
      },
      tooltip: {
        trigger: 'axis',
        // force the pointer to be vertical (it defaults to horizontal for categorical data)
        axisPointer: {
          axis: 'x',
        },
        // use a custom tooltip formatter in order to make the label timezone aware
        formatter: (params) => {
          let tooltip = `<div>${dateTime(params[0].axisValue, timezone)}`;
          params.forEach((p) => {
            // values with 'name' are ordinal and don't need a unit label
            const unit = p.name ? '' : ` ${units[p.seriesId]}`;
            const val = parseStringToFloat(p.value[1]) || p.value[1];
            tooltip += `<br /> ${p.marker}${p.seriesName}: ${val?.toLocaleString()}${unit}`;
          });
          tooltip += '</div>';
          return tooltip;
        },
      },
      legend: {
        type: 'scroll',
        orient: 'horizontal',
        data: labels,
        top: '90%',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: 'Save',
          },
        },
      },
      xAxis: {
        type: 'time',
        boundaryGap: false,
        axisLabel: {
          formatter: (value) => dateTime(value, timezone),
        },
        data: xAxisData,
      },
      color: ECHARTS_COLORS,
      yAxis,
      series,
    };
    return option;
  }

  render() {
    if (!this.props.yAxis?.length) {
      return <div>No data</div>;
    }
    // Note: need to set the `notMerge` option on the chart, otherwise it will preserve
    // any series data you send it and do wonky things when you give it a new range or data
    return <ReactEcharts option={this.getOption()} notMerge />;
  }
}

export default connect(
  ({
    entities: {
      points: { units },
    },
  }) => ({ units })
)(TrendGraph);
